<template>
  <teleport to="#modal-container">
    <transition name="fade">
      <div
        v-if="isOpen"
        class="modal show d-flex justify-content-center align-items-center"
        tabindex="-1"
        role="dialog"
        @click.self="close"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header d-flex justify-content-end">
              <CloseButton
                :classes="['ts-x-black', 'bg-grey-200']"
                @click="close"
              ></CloseButton>
            </div>
            <div class="modal-body">
              <slot></slot>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <!-- Default footer slot content -->
                <button type="button" class="btn btn-secondary" @click="close">
                  Close
                </button>
              </slot>
            </div>
          </div>
        </div>
        <div class="modal-backdrop fade show"></div>
      </div>
    </transition>
  </teleport>
</template>

<script setup lang="ts">
  import { ref } from 'vue'

  // UI components
  import CloseButton from '@/components/UI/Button.vue'

  const emit = defineEmits<{
    close: []
  }>()

  const isOpen = ref(false)

  function close(): void {
    isOpen.value = false
    emit('close')
  }

  function open(): void {
    isOpen.value = true
  }

  defineExpose({ open, close })
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  .modal-backdrop {
    z-index: 1030 !important;
  }

  .modal {
    z-index: 10000;
  }

  .modal-content {
    z-index: 100001;
    background-color: var(--primary-white);
  }
</style>
